import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import format from 'date-fns/format';

import { getAsset } from '../../../../util/assets';
import Badge from '../../Badge';
import PriceDisplay from '../../PriceDisplay';
import Button from '../../Button';
import { formatPriceForDisplay } from '../../../../util/format-money';

const propTypes = {
  className: PropTypes.string,
  albumFolder: PropTypes.shape({
    id: PropTypes.string.isRequired,
  }).isRequired,
  identity: PropTypes.shape({
    id: PropTypes.string.isRequired,
  }),
  cartItem: PropTypes.shape({
    id: PropTypes.string.isRequired,
  }),
  isPurchased: PropTypes.bool,
  onSubscriptionToggle: PropTypes.func.isRequired,
};

const AlbumFolderSubscriptionOption = ({
  className,
  albumFolder,
  cartItem,
  isPurchased,
  onSubscriptionToggle,
}) => {
  const classes = classNames({
    [className]: !!className,
    'purchasing-option-item': true,
    'purchasing-option-item-album-folder': true,
    'is-selected': !!cartItem,
  });

  const renderSubscriptionPrice = () => {
    const price = albumFolder.price.value;
    const discountPrice = albumFolder.limited_time_offer_active
      ? albumFolder.limited_time_offer_price.value
      : undefined;

    return (
      <PriceDisplay
        price={discountPrice || price}
        oldPrice={price}
        showDiscount
      />
    );
  };

  return (
    <div className={classes}>
      <div className="purchasing-option-item-thumb">
        <img width={75} src={getAsset('/photopass.svg')} alt="" />
      </div>

      <div className="purchasing-option-item-content-wrap">
        <span className="purchasing-option-item-title">Digital Photo Pass</span>

        <div className="purchasing-option-item-info-extra">
          <Badge badgeStyle="yellow" className="text-extra-bold">
            {renderSubscriptionPrice()}
          </Badge>
        </div>

        <div className="purchasing-option-item-content mb-2">
          <p className="text-sm lh-normal text-dark text-bold">
            All your high resolution images from this event at one price
          </p>

          {albumFolder.limited_time_offer_active && (
            <span className="d-block text-sm text-italic mt-1">
              Only $
              {formatPriceForDisplay(
                albumFolder.limited_time_offer_price.value,
              )}{' '}
              if you buy before{' '}
              <span className="text-extra-bold">
                {format(
                  new Date(albumFolder.limited_time_offer_date_end),
                  'MMMM Mo',
                )}
              </span>
              .
            </span>
          )}
        </div>

        {isPurchased && (
          <Button
            btnStyle="success-vibrant"
            className="purchasing-options-item-btn"
            disabled
            onClick={() => onSubscriptionToggle()}
          >
            Purchased
          </Button>
        )}
        {!isPurchased && (
          <Button
            btnStyle={classNames({
              primary: !cartItem,
              info: !!cartItem,
            })}
            className={classNames({
              'purchasing-options-item-btn': true,
              'btn-purchase-options-in-cart': !!cartItem,
            })}
            onClick={() => onSubscriptionToggle()}
          >
            {cartItem ? (
              <Fragment>In cart</Fragment>
            ) : (
              <Fragment>Add to cart</Fragment>
            )}
          </Button>
        )}
      </div>
    </div>
  );
};

AlbumFolderSubscriptionOption.propTypes = propTypes;

export default AlbumFolderSubscriptionOption;
